export default (vault) => {
    return (dispatch) => {
        dispatch({type: 'NEW_VAULT', payload: vault })
    }
}